import { reactive } from "vue"

/**
 *
 * @param {import("@vue/reactivity").Ref<import("@/core/Campaign/model/CampaignModel").default>} campaign
 */
export const useAddToBagButton = function (campaign) {

    const state = reactive({
        isAllow: true,
        isDisable: false,
        btnLbl: '',
    });

    if (campaign.value.isConditionPass) {
        state.isAllow = true
    } else {
        state.isAllow = false
    }

    return state
}

export default useAddToBagButton
